import { render, staticRenderFns } from "./CompactMultiSelect.vue?vue&type=template&id=630a4d8c"
import script from "./CompactMultiSelect.vue?vue&type=script&lang=js"
export * from "./CompactMultiSelect.vue?vue&type=script&lang=js"
import style0 from "./CompactMultiSelect.vue?vue&type=style&index=0&id=630a4d8c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports